import { Check } from "lucide-react";
import { AttrIcon } from "@/components/AttributesPanel";

export const AttributeFilter = ({ sport, tags, season, value, onChange }) => {
  if (!tags?.length) return null;
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div data-testid="filter-attributes">
      <div className="mb-2 flex items-center justify-between">
        <span className="eyebrow">Attributes · {season}</span>
        {value.length > 0 && (
          <button data-testid="filter-attributes-clear" onClick={() => onChange([])}
            className="font-data text-[10px] uppercase tracking-wider text-slate-400 transition-colors duration-200 hover:text-[#FF2D78]">Clear</button>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {tags.map((t) => {
          const on = value.includes(t.key);
          return (
            <button key={t.key} data-testid={`filter-attribute-${t.key}`} aria-pressed={on} onClick={() => toggle(t.key)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs transition-colors duration-200 ${on ? "border-[#FF2D78] bg-[#FF2D78]/20 text-white" : "border-slate-700 text-slate-300 hover:border-slate-500"}`}>
              {on ? <Check className="h-3.5 w-3.5 text-[#FF2D78]" /> : <span className="text-[#FF2D78]"><AttrIcon file={t.icon} sport={sport} className="h-3.5 w-3.5" /></span>}
              {t.label} <span className="font-data text-[10px] text-slate-500">{t.count}</span>
            </button>
          );
        })}
      </div>
      {value.length > 1 && <p className="mt-2 text-[11px] text-slate-500">Showing players with all selected attributes.</p>}
    </div>
  );
};
